import { CandidateCard } from "../../../../models/candidateCard";
import { CandidateCardQueryFilter } from "../../../../models/candidateCardQueryFilter";
import { JobMatchQueryFilter } from "../../../../models/jobMatchQueryFilter";
import * as CandidateCommunicationModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidates/candidateCard/candidate-card-communication-modal.html';
import * as CandidateActionModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidates/candidateCard/candidate-card-actions-modal.html';
import * as CandidateActivitiesModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidates/candidateCard/candidate-activities-modal.html';
import * as CandidateCardNoteModal from 'raw-loader!src/app/public/app/partials/missioncontrol/candidates/candidateCard/candidate-card-notes-modal.html';
import { RunCandidateScore } from "src/app/public/app/models/runCandidateScore";
import { FormalizeCandidate, FormalizeCompany } from "src/app/public/app/models/formalizePayload";
var CandidateCardController = /** @class */ (function () {
    /*@ngInject*/
    function CandidateCardController($uibModal, $rootScope, $timeout, $state, $filter, candidateService, jobMatchService, jobService, userRoleService, webSocketsService, StorageService, alertsAndNotificationsService, sharedAjsService, resumeService, jobMatchActionsService, sharedService) {
        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$state = $state;
        this.$filter = $filter;
        this.candidateService = candidateService;
        this.jobService = jobService;
        this.jobMatchService = jobMatchService;
        this.userRoleService = userRoleService;
        this.webSocketsService = webSocketsService;
        this.StorageService = StorageService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.sharedAjsService = sharedAjsService;
        this.resumeService = resumeService;
        this.jobMatchActionsService = jobMatchActionsService;
        this.sharedService = sharedService;
    }
    CandidateCardController.prototype.$onInit = function () {
        //variables
        this.candidate = null;
        this.candidateJobMatches = [];
        this.notifications = [];
        this.newNotifications = [];
        this.candidateCardNotesModal = null;
        this.candidateCardCommunicationModal = null;
        this.candidateCardPeerCommunicationModal = null;
        this.candidateCardShowAllActivitiesModal = null;
        this.showCurrentJobDetails = false;
        this.notificationsSearchObject = {};
        this.userNotificationControls = {};
        this.recentActivitiesControls = {};
        this.recentActivitiesControls.activityClickCount = 0;
        this.isActivityClicked = false;
        this.jobMatchesObject = {};
        this.numberOfNewNotifications = 0;
        this.recentActivities = [];
        this.clientOrBuLabel = 'Client';
        this.filledOrJoinedText = '';
        this.isUserAdmin = false;
        this.formalizeActivityPayload = null;
        //flags
        this.loadingFlag = true;
        this.hasCandidateJoined = false;
        this.showAdditionalDetailsIcons = false;
        this.filtersEnabled = false;
        this.showFilledOrJoinedHeader = false;
        this.showFilledOrJoinedOnCard = false;
        this.showSalary = true;
        // flag used to reload the notifications directive.
        this.showNotificationsFlag = false;
        // flag used to reload the recent activities directive.
        this.showRecentActivitiesFlag = false;
        this.listenToIncomingChatMessage();
        this._subscribeToCandidateCardRefreshEvent();
        this.init(false);
    };
    CandidateCardController.prototype.init = function (isRefresh) {
        this.userName = this.$rootScope.userDetails.firstname + ' ' + this.$rootScope.userDetails.lastname;
        if (this.$rootScope.userDetails.company.companyType === this.$rootScope.MESSAGECONSTANTS.COMPANY_TYPES.CORPORATE) {
            this.clientOrBuLabel = 'BU';
        }
        this.candidate = new CandidateCard();
        if (_.isUndefined(this.filterParams)) {
            this.filterParams = new CandidateCardQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id);
        }
        if (_.isUndefined(this.activityMap)) {
            this.activityMap = [];
        }
        if (_.isUndefined(this.jobMatchesPopoverPosition)) {
            this.jobMatchesPopoverPosition = 'bottom';
        }
        if (_.isUndefined(this.setCandidateInfo)) {
            this.setCandidateInfo = function () {
                // do nothing
            };
        }
        this.isUserAdmin = this.userRoleService.isLoggedInUserAnAdmin();
        this.isSuperUser = this.userRoleService.isLoggedInUserSuperUser();
        this.is4dot5UserAdmin = this.userRoleService.isLoggedInUser4dot5Admin();
        this.numberOfNewNotifications = 0;
        this.notificationsSearchObject.page = 1;
        this.notificationsSearchObject.size = 3;
        this.notificationsSearchObject.candidateId = this.candidateInfo.id;
        this.notificationsSearchObject.companyId = this.$rootScope.userDetails.company.companyId;
        this.notificationsSearchObject.notifyOn = 'CANDIDATE_CARD';
        this.userNotificationControls.setNewNotificationsAsViewed = null;
        this.userNotificationControls.notificationClickCount = 0;
        this.recentActivitiesControls.getActivities = null;
        this.showAdditionalDetailsIcons = false;
        this.showNotificationsFlag = true;
        this.showRecentActivitiesFlag = true;
        this.isNotificationClicked = false;
        //get the candidate card
        this.getCandidateCardInfo(isRefresh);
    };
    CandidateCardController.prototype._subscribeToCandidateCardRefreshEvent = function () {
        var _this = this;
        this.$rootScope.$on("refreshCandidateCard", function (event, data) {
            if (data.candidateId == _this.candidateInfo.id) {
                if ((data.type == 'candidateCard' || data.type == 'candidateJobMatchCard') && _this.jobMatchesActiveTab && _this.jobMatchesActiveTab.candidateInfoContainerId) {
                    _this.refreshCard(true, true);
                }
                else {
                    _this.refreshCard(true, false);
                }
            }
        });
    };
    CandidateCardController.prototype.listenToIncomingChatMessage = function () {
        var _this = this;
        this.webSocketsService.receiveMessage().then(null, null, function (message) {
            if (message.candidateId == _this.candidateInfo.id) {
                _this.candidate.unreadMessageCount++;
            }
        });
    };
    CandidateCardController.prototype.getCandidateCardInfo = function (isRefresh) {
        var _this = this;
        this.loadingFlag = true;
        this.filterParams.vendorIds = this.filterParams.vendors;
        var filterParams = _.pick(this.filterParams, Object.keys(new CandidateCardQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id)));
        var filterParamsCopy = angular.copy(filterParams);
        this.showSalary = filterParamsCopy.candidateType == "OWN_CANDIDATES";
        if (isRefresh) {
            filterParams = new CandidateCardQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id);
            filterParams.candidateType = filterParamsCopy.candidateType;
        }
        this.candidateService.getCandidateCard(this.candidateInfo.id, this.userId, filterParams, function (data) {
            angular.merge(_this.candidate, data);
            _this.candidate = _this._massageCandidateData(_this.candidate);
            _this._setCardFaceInfo();
            _this._setJobMatchesFilter();
            _this.loadingFlag = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    CandidateCardController.prototype._setCardFaceInfo = function () {
        if (this.filterParams.roleList.length > 0
            || this.filterParams.recruiterList.length > 0
            || this.filterParams.requisitionNumbers.length > 0
            || this.filterParams.clientOrBuList.length > 0
            || this.filterParams.requisitionStatus.length > 0
            || this.filterParams.workflowStates.length > 0) {
            this.filtersEnabled = true;
        }
        else {
            this.filtersEnabled = false;
        }
        if (this.filtersEnabled && (this.candidate.bestMatchJobCurrentState == 'Filled' || this.candidate.bestMatchJobCurrentState == 'Joined')) {
            this.showFilledOrJoinedOnCard = true;
        }
        else if (!this.filtersEnabled && this.candidate.candidateFilledOrJoinedToOwnJob) {
            this.showFilledOrJoinedOnCard = true;
        }
        else {
            this.showFilledOrJoinedOnCard = false;
        }
        var jobWorkLocations = this.showFilledOrJoinedOnCard ? this.candidate.filledOrJoinedMatchWorkLocations : this.candidate.bestJobMatchWorkLocations;
        this.candidate.workLocationsMatchStatus = this.jobMatchService.getJobAndCandidateWorkLocationsMatchStatus(jobWorkLocations, this.candidate.workLocations);
        if (!this.filtersEnabled) {
            if (this.candidate.anyJobMatchFilledOrJoined && !this.candidate.candidateFilledOrJoinedToOwnJob) {
                this.showFilledOrJoinedHeader = true;
            }
            else {
                this.showFilledOrJoinedHeader = false;
            }
        }
        else {
            if ((this.candidate.bestMatchJobCurrentState !== 'Filled' && this.candidate.bestMatchJobCurrentState !== 'Joined') && (this.candidate.anyJobMatchFilledOrJoined || this.candidate.candidateFilledOrJoinedToOwnJob)) {
                this.showFilledOrJoinedHeader = true;
            }
            else {
                this.showFilledOrJoinedHeader = false;
            }
        }
    };
    CandidateCardController.prototype._massageCandidateData = function (candidate) {
        candidate.name = this._setCandidateName(candidate);
        if (candidate.bestMatchJobRequisitionNum == null) {
            candidate.bestMatchJobRequisitionNum = '-';
        }
        if (_.isNull(candidate.currentJobCompanyName) || candidate.currentJobCompanyName == '') {
            candidate.currentJobCompanyName = '-';
        }
        if (_.isNull(candidate.currentJobDuration) || candidate.currentJobDuration == '') {
            candidate.currentJobDuration = '-';
        }
        else {
            candidate.currentJobDurationText = candidate.currentJobDuration.replace("-", " to ");
        }
        if (_.isNull(candidate.currentJobLocation) || candidate.currentJobLocation == '') {
            candidate.currentJobLocation = '-';
        }
        if (_.isNull(candidate.currentJobTitle) || candidate.currentJobTitle == '') {
            candidate.currentJobTitle = '-';
        }
        candidate.currentJobCompanyNameTooltip = "Company of Latest Job.";
        candidate.currentJobTitleTooltip = "Title of Latest Job.";
        candidate.currentJobLocationToolTip = "Location of Latest Job.";
        if (candidate.currentJobCompanyName.length > 30) {
            candidate.currentJobCompanyNameTooltip = candidate.currentJobCompanyNameTooltip + "- " + candidate.currentJobCompanyName;
        }
        if (candidate.currentJobLocation.length > 30) {
            candidate.currentJobLocationToolTip = candidate.currentJobLocationToolTip + "- " + candidate.currentJobLocation;
        }
        if (candidate.currentJobTitle.length > 30) {
            candidate.currentJobTitleTooltip = candidate.currentJobTitleTooltip + "- " + candidate.currentJobTitle;
        }
        if (candidate.candidateStatus === 'INERT') {
            this.showCurrentJobDetails = true;
            if (candidate.currentJobCompanyName == '-' && candidate.currentJobDuration == '-' && candidate.currentJobLocation == '-' && candidate.currentJobTitle == '-') {
                this.showCurrentJobDetails = false;
            }
        }
        if (_.isNull(candidate.assignedRecruiterOfBestJobMatch)) {
            candidate.bestMatchRecruiterName = '';
        }
        else {
            candidate.bestMatchRecruiterName = candidate.assignedRecruiterOfBestJobMatch;
        }
        if (_.isNull(candidate.bestMatchClientName)) {
            candidate.bestMatchClientName = "";
        }
        if (!_.isNull(candidate.bestJobMatchSharedClientName)) {
            if (candidate.bestMatchClientName == "") {
                candidate.bestMatchClientName = candidate.bestMatchClientName + ' @ ' + candidate.bestJobMatchSharedClientName;
            }
            else {
                candidate.bestMatchClientName = candidate.bestJobMatchSharedClientName;
            }
        }
        candidate.bestJobmatchJobLocationHtmlText = '';
        if (!_.isNull(candidate.bestJobmatchJobLocation)) {
            candidate.bestJobmatchJobLocationHtmlText = this.jobService.getParsedJobLocationText(candidate.bestJobmatchJobLocation, false);
        }
        candidate.bestMatchClientName = candidate.bestMatchClientName + candidate.bestJobmatchJobLocationHtmlText;
        if (_.isNull(candidate.filledOrJoinedMatchClientName)) {
            candidate.filledOrJoinedMatchClientName = "";
        }
        candidate.joinedOrFilledJobLocationHtmlText = '';
        if (!_.isNull(candidate.joinedOrFilledJobLocation)) {
            candidate.joinedOrFilledJobLocationHtmlText = this.jobService.getParsedJobLocationText(candidate.joinedOrFilledJobLocation, false);
        }
        if (!_.isNull(candidate.filledOrJoinedMatchSharedClientName)) {
            candidate.filledOrJoinedMatchClientName = candidate.filledOrJoinedMatchClientName + ' @ ' + candidate.filledOrJoinedMatchSharedClientName;
        }
        candidate.filledOrJoinedMatchClientName = candidate.filledOrJoinedMatchClientName + candidate.joinedOrFilledJobLocationHtmlText;
        candidate.lastModifiedDate = new Date(candidate.lastModifiedDate);
        candidate.bestMatchJobDate = new Date(candidate.bestMatchJobDate);
        if (candidate.filledOrJoinedMatchJobCurrentState == 'Joined') {
            this.hasCandidateJoined = true;
        }
        if (this.hasCandidateJoined) {
            this.filledOrJoinedText = 'Join';
            // candidate.jobLeftDate = null;
        }
        else {
            this.filledOrJoinedText = 'Fill';
        }
        if (candidate.mobilePhoneCountryCodePresent) {
            var phoneNumberObject = libphonenumber.parse(candidate.mobilephone.toString());
            if (phoneNumberObject.phone !== undefined) {
                candidate.mobilephone = libphonenumber.format(phoneNumberObject.phone, phoneNumberObject.country, 'International');
            }
        }
        if (candidate.fromOtherSource) {
            candidate.otherSourceNote = "<span>Source: Other<br>Notes: " + candidate.otherSourceTypeNotes + "</span>";
        }
        if (this.candidateInfo.context && this.candidateInfo.context != '') {
            candidate.context = this.candidateInfo.context;
        }
        this.showAdditionalDetailsIcons = true;
        this.candidate.recruiterListMessage = "N/A";
        if (this.candidate.recruitersList && this.candidate.recruitersList.length > 0) {
            var recruiterListMessage_1 = [];
            this.candidate.recruitersList.map(function (recruiter, key) {
                recruiterListMessage_1.push("" + (key != 0 ? " " : "") + recruiter);
            });
            this.candidate.recruiterListMessage = recruiterListMessage_1.toString();
        }
        return candidate;
    };
    CandidateCardController.prototype._setCandidateName = function (candidate) {
        if (_.isNull(candidate.firstName)) {
            candidate.firstName = "-";
        }
        if (_.isNull(candidate.lastName)) {
            candidate.lastName = "-";
        }
        if (candidate.firstName == "-" && candidate.lastName == "-") {
            candidate.nameWarning = 'First and Last Name Missing';
        }
        else if (candidate.firstName == "-") {
            candidate.nameWarning = "First Name Missing";
        }
        else if (candidate.lastName == "-") {
            candidate.nameWarning = "Last Name Missing";
        }
        else {
            candidate.nameWarning = "";
        }
        return candidate.firstName + ' ' + candidate.lastName;
    };
    CandidateCardController.prototype._setJobMatchesFilter = function () {
        this.jobMatchesObject = new JobMatchQueryFilter();
        this.jobMatchesObject.candidateId = this.candidateInfo.id;
        this.jobMatchesObject.userId = this.$rootScope.userDetails.id;
        this.jobMatchesObject.companyId = this.$rootScope.userDetails.company.companyId;
        this.jobMatchesObject.top5Flag = true;
        this.jobMatchesObject.candidateType = this.candidateType;
        this.jobMatchesObject.searchText = '';
        this.jobMatchesObject.vendorIds = this.filterParams.vendors;
    };
    CandidateCardController.prototype.launchNotesModal = function () {
        var candidateinfo = this._setCandidateEmailSubjectAndBody(this.candidate);
        var candidateInformationList = candidateinfo.candidateInfoInEmailBody;
        var candidateDetails = {
            firstName: this.candidate.firstName,
            lastName: this.candidate.lastName,
            candidateId: this.candidate.id,
        };
        var companyDetails = {
            companyId: this.$rootScope.userDetails.company.companyId,
            companyName: this.$rootScope.userDetails.company.companyName,
            clientOrBUId: this.candidate.clientOrBUId,
            clientOrBUName: this.candidate.bestMatchClientName
        };
        var vm = this;
        this.candidateCardNotesModal = this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            windowTopClass: 'four-dot-five-modal-medium',
            template: CandidateCardNoteModal.default,
            controller: ['$uibModalInstance', 'jobMatchId', 'candidateInformationList', 'candidateDetails', 'companyDetails', function ($uibModalInstance, jobMatchId, candidateInformationList, candidateDetails, companyDetails) {
                    this.jobMatchId = jobMatchId;
                    this.candidateInformationList = candidateInformationList;
                    this.candidateDetails = candidateDetails;
                    this.companyDetails = companyDetails;
                    this.closeModal = function () {
                        $uibModalInstance.close('cancel');
                    };
                }],
            controllerAs: 'notesModal',
            size: 'md',
            resolve: {
                jobMatchId: function () {
                    return vm.candidate.bestMatchId;
                },
                candidateInformationList: function () {
                    return candidateInformationList;
                },
                candidateDetails: function () {
                    return candidateDetails;
                },
                companyDetails: function () {
                    return companyDetails;
                }
            }
        });
    };
    CandidateCardController.prototype.launchCommunicationModal = function (isPeerCommunication) {
        var communicationType = "candidate";
        var windowTopClass = "four-dot-five-modal-medium";
        if (isPeerCommunication) {
            communicationType = "peer";
            windowTopClass = "four-dot-five-modal-extra-large";
        }
        var candidateinfo = this._setCandidateEmailSubjectAndBody(this.candidate);
        var candidateInformationList = candidateinfo.candidateInfoInEmailBody;
        var vm = this;
        this.candidateCardCommunicationModal = this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            backdrop: 'static',
            template: CandidateCommunicationModal.default,
            windowTopClass: windowTopClass,
            controller: ['$uibModalInstance', 'candidateId', 'jobMatchId', 'jobId', 'communicationType', 'jobMatchesFilter', 'candidateInformationList', 'companyId', 'userId', 'clientOrBUId', 'jobMatches', 'candidateType', function ($uibModalInstance, candidateId, jobMatchId, jobId, communicationType, jobMatchesFilter, candidateInformationList, companyId, userId, clientOrBUId, jobMatches, candidateType) {
                    var ctrl = this;
                    ctrl.candidateId = candidateId;
                    ctrl.jobMatchId = jobMatchId;
                    ctrl.jobId = jobId;
                    ctrl.communicationType = communicationType;
                    ctrl.jobMatchesFilter = jobMatchesFilter;
                    ctrl.candidateInformationList = candidateInformationList;
                    ctrl.companyId = companyId;
                    ctrl.userId = userId;
                    ctrl.clientOrBUId = clientOrBUId;
                    ctrl.jobMatches = jobMatches;
                    ctrl.candidateType = candidateType;
                    ctrl.closeModal = function () {
                        if (communicationType == 'peer') {
                            vm.refreshCard(false, false);
                        }
                        $uibModalInstance.close('cancel');
                    };
                }],
            controllerAs: 'communicationModal',
            size: 'md',
            resolve: {
                candidateId: function () {
                    return vm.candidateInfo.id;
                },
                jobMatchId: function () {
                    return vm.candidate.bestMatchId;
                },
                jobId: function () {
                    return vm.candidate.bestMatchJobId;
                },
                communicationType: function () {
                    return communicationType;
                },
                jobMatchesFilter: function () {
                    return vm.jobMatchesObject;
                },
                candidateInformationList: function () {
                    return candidateInformationList;
                },
                companyId: function () {
                    return vm.$rootScope.userDetails.company.companyId;
                },
                userId: function () {
                    return vm.$rootScope.userDetails.id;
                },
                clientOrBUId: function () {
                    return vm.candidate.clientOrBUId;
                },
                jobMatches: function () {
                    return [];
                },
                candidateType: function () {
                    return vm.candidateType;
                }
            }
        });
    };
    CandidateCardController.prototype.launchActionsModal = function (type, action) {
        var _this = this;
        var actionType = '';
        var actionLabel = '';
        var windowTopClass = 'four-dot-five-modal-small';
        switch (type) {
            case 'availability':
                actionType = 'availability';
                actionLabel = 'Set Candidate Availability Date';
                break;
            case 'jobLeft':
                actionType = 'jobLeft';
                actionLabel = 'Job Left';
                windowTopClass = 'four-dot-five-modal-medium';
                break;
            case 'delete':
                actionType = 'delete';
                actionLabel = 'Delete Candidate';
                break;
            case 'updateContact':
                actionType = 'updateContact';
                actionLabel = 'Update Candidate Contact Details';
                windowTopClass = 'four-dot-five-modal-medium';
                break;
            case 'profile':
                actionType = 'profile';
                actionLabel = this.candidate.name + "'s" + " " + 'Booklet';
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'bestMatchJobProfile':
                actionType = 'bestMatchJobProfile';
                actionLabel = 'Best Match Job Profile';
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'uploadResume':
                actionType = 'uploadResume';
                actionLabel = 'Upload Resume';
                windowTopClass = 'four-dot-five-modal-large';
                break;
            case 'runCandidateScore':
                actionType = 'runCandidateScore';
                actionLabel = 'Run Candidate Score';
                windowTopClass = 'four-dot-five-modal-medium';
                break;
            case 'doNotHire':
                actionType = 'doNotHire';
                actionLabel = 'Do Not Hire';
                windowTopClass = 'four-dot-five-modal-medium';
                break;
            case 'emailDocument':
                actionType = 'emailDocument';
                actionLabel = 'Send Email';
                windowTopClass = 'four-dot-five-modal-extra-large';
                break;
            case 'clientReview':
                actionType = 'clientReview';
                actionLabel = 'Client Review';
                windowTopClass = 'four-dot-five-modal-extra-large';
                break;
            case 'sendOutreach':
                actionType = 'sendOutreach';
                actionLabel = "<span>Send Outreach to Candidate <b>'" + this.candidate.name + "'</b></span>";
                windowTopClass = 'four-dot-five-modal-extra-large';
                break;
            default:
                break;
        }
        if (actionType == 'delete' && (this.candidate.anyJobMatchFilledOrJoined || this.candidate.candidateFilledOrJoinedToOwnJob)) {
            var message = "Candidate <span class='emerald'>'" + this.candidate.name + "'</span> cannot be deleted as he/she is in <span class='emerald'>'" + this.filledOrJoinedText + "ed'</span> state";
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Cannot Delete Candidate</strong></div>",
                message: message,
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                }
            });
        }
        else if (actionType == 'runCandidateScore') {
            this.alertsAndNotificationsService.showConfirm(actionLabel, "Are you sure you want to run the candidate score?", "warning", true, function () {
                var requestObject = new RunCandidateScore(_this.$rootScope.userDetails.company.companyId, _this.$rootScope.userDetails.id);
                requestObject.candidateId = _this.candidate.id;
                requestObject.rerunType = "CANDIDATE";
                requestObject.candidateType = _this.candidateType;
                _this.resumeService.reRunResumeScore(requestObject, function (data) {
                    _this.alertsAndNotificationsService.showAlertWithCallBack("Candidate scoring in Progress", data.message, "success", function () { });
                }, function (error) {
                    _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }, function () {
                //do nothing
            });
        }
        else {
            var jobMatchId_1 = "";
            var jobId_1 = "";
            if ((actionType == 'jobLeft' || this.showFilledOrJoinedOnCard) && this.candidate.filledOrJoinedMatchId !== null) {
                jobId_1 = this.candidate.filledOrJoinedMatchJobId;
                jobMatchId_1 = this.candidate.filledOrJoinedMatchId;
            }
            else if (this.candidate.bestMatchId !== null) {
                jobId_1 = this.candidate.bestMatchJobId;
                jobMatchId_1 = this.candidate.bestMatchId;
            }
            var candidateDetails_1 = {
                context: 'candidateCard',
                candidateId: this.candidate.id,
                companyId: this.$rootScope.userDetails.company.companyId,
                jobMatchId: jobMatchId_1,
                hasResume: this.candidate.hasResume,
                resumeFileName: this.candidate.resumePdfFileName,
                resumeXRXml: this.candidate.resumePdfFileName ? this.candidate.resumePdfFileName.replace(/\.\w+/, '.xml') : '',
                candidateType: this.candidateType,
                showOnlyJobMatchUsers: true,
                candidateEmailSubjectAndBodyInformation: this._setCandidateEmailSubjectAndBody(this.candidate),
                vendorId: this._setCandidateVendorDetails(this.candidate),
                name: this.candidate.firstName + this.candidate.lastName
            };
            if (action === 'email') {
                candidateDetails_1.candidateEmail = this.candidate.email;
            }
            else {
                candidateDetails_1.candidateEmail = null;
            }
            var formalizeActivityPayload_1 = {
                candidate: new FormalizeCandidate(this.candidate.id, this.candidate.firstName, this.candidate.lastName),
                requisition: null,
                jobMatch: null,
                company: new FormalizeCompany(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.company.companyName, "", "")
            };
            var vm_1 = this;
            this.candidateCardActionsModal = this.$uibModal.open({
                animation: false,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                template: CandidateActionModal.default,
                backdrop: 'static',
                windowTopClass: windowTopClass,
                controller: ['$uibModalInstance', 'candidateId', 'candidateName', 'bestJobMatchId', 'bestMatchJobId', 'candidateInfo', 'actionType', 'actionLabel', 'availabilityDate', 'joinedDate', 'deleteCandidateCallback', 'candidateDetails', 'salaryDurationOptions', 'jobTypeList', 'formalizeActivityPayload',
                    function ($uibModalInstance, candidateId, candidateName, bestJobMatchId, bestMatchJobId, candidateInfo, actionType, actionLabel, availabilityDate, joinedDate, deleteCandidateCallback, candidateDetails, salaryDurationOptions, jobTypeList, formalizeActivityPayload) {
                        var ctrl = this;
                        ctrl.candidateId = candidateId;
                        ctrl.candidateName = candidateName;
                        ctrl.bestJobMatchId = bestJobMatchId;
                        ctrl.bestMatchJobId = bestMatchJobId;
                        ctrl.candidateInfo = candidateInfo;
                        ctrl.actionType = actionType;
                        ctrl.actionLabel = actionLabel;
                        ctrl.availabilityDate = availabilityDate;
                        ctrl.joinedDate = joinedDate;
                        ctrl.deleteCandidateCallback = deleteCandidateCallback;
                        ctrl.candidateDetails = candidateDetails;
                        ctrl.salaryDurationOptions = salaryDurationOptions;
                        ctrl.jobTypeList = jobTypeList;
                        ctrl.formalizeActivityPayload = formalizeActivityPayload;
                        ctrl.closeModal = function () {
                            $uibModalInstance.close('cancel');
                        };
                        ctrl.saveCallback = function () {
                            if (ctrl.actionType == 'updateContact' || ctrl.actionType == 'availability' || ctrl.actionType == 'jobLeft' || ctrl.actionType == 'uploadResume' || ctrl.actionType == 'doNotHire' || ctrl.actionType == 'clientReview' || ctrl.actionType == 'emailDocument') {
                                vm_1.$timeout(function () {
                                    vm_1.refreshCard((ctrl.actionType === 'jobLeft' || ctrl.actionType == 'updateContact' || ctrl.actionType == 'clientReview' || ctrl.actionType == 'emailDocument'), (ctrl.actionType === 'jobLeft' || ctrl.actionType == 'updateContact'));
                                }, 1000);
                            }
                            if (actionType != 'updateContact') {
                                ctrl.closeModal();
                            }
                        };
                        ctrl.deleteCallback = function () {
                            ctrl.deleteCandidateCallback();
                            ctrl.closeModal();
                        };
                    }],
                controllerAs: 'actionsModal',
                size: 'lg',
                resolve: {
                    actionType: function () {
                        return actionType;
                    },
                    actionLabel: function () {
                        return actionLabel;
                    },
                    candidateId: function () {
                        return vm_1.candidateInfo.id;
                    },
                    candidateName: function () {
                        return vm_1.candidate.name;
                    },
                    bestJobMatchId: function () {
                        return jobMatchId_1;
                    },
                    bestMatchJobId: function () {
                        return jobId_1;
                    },
                    availabilityDate: function () {
                        return vm_1.candidate.availabilityDate;
                    },
                    joinedDate: function () {
                        return vm_1.candidate.filledOrJoinedMatchJobDate;
                    },
                    candidateInfo: function () {
                        return {
                            candidateId: vm_1.candidateInfo.id,
                            candidateName: vm_1.candidate.name,
                            jobMatchCount: vm_1.candidate.jobMatchesCount,
                            emailId: vm_1.candidate.email,
                            phoneNumber: vm_1.candidate.mobilephone
                        };
                    },
                    deleteCandidateCallback: function () {
                        return vm_1.deleteCallback;
                    },
                    candidateDetails: function () {
                        return candidateDetails_1;
                    },
                    salaryDurationOptions: function () {
                        return vm_1.salaryDurationOptions;
                    },
                    jobTypeList: function () {
                        return vm_1.jobTypeList;
                    },
                    formalizeActivityPayload: function () {
                        return formalizeActivityPayload_1;
                    }
                }
            });
        }
    };
    CandidateCardController.prototype.showAllActivityModal = function () {
        var vm = this;
        this.candidateCardShowAllActivitiesModal = this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: CandidateActivitiesModal.default,
            windowClass: 'candidate-activities-modal-window',
            controller: ['$uibModalInstance', 'candidateInfo', 'jobMatchId', 'activityMap', function ($uibModalInstance, candidateInfo, jobMatchId, activityMap) {
                    this.candidateInfo = candidateInfo;
                    this.jobMatchId = jobMatchId;
                    this.activityMap = activityMap;
                    this.closeModal = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }],
            controllerAs: 'activityModal',
            size: 'lg',
            resolve: {
                candidateInfo: function () {
                    return vm.candidate;
                },
                jobMatchId: function () {
                    return undefined;
                },
                activityMap: function () {
                    return vm.activityMap;
                }
            }
        });
    };
    CandidateCardController.prototype.refreshCard = function (refreshWithoutFilters, refreshJobMatches) {
        var _this = this;
        this.showNotificationsFlag = false;
        this.showRecentActivitiesFlag = false;
        //Give time to hide and show recent activities and notifications directives
        this.$timeout(function () {
            // re initialize
            _this.init(refreshWithoutFilters);
            if (refreshJobMatches) {
                _this._refreshJobMatches();
            }
        }, 300);
    };
    CandidateCardController.prototype._refreshJobMatches = function () {
        this.sharedAjsService.raiseRefreshJobMatchesEvent(this.candidateInfo.id, this.jobMatchesActiveTab.type);
    };
    CandidateCardController.prototype.showRecentActivities = function () {
        this.recentActivitiesControls.activityClickCount++;
        this.isActivityClicked = !this.isActivityClicked;
    };
    CandidateCardController.prototype.showNotifications = function () {
        this.userNotificationControls.notificationClickCount++;
        this.isNotificationClicked = !this.isNotificationClicked;
    };
    CandidateCardController.prototype.confirmOpeningPhoneConference = function () {
        var _this = this;
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: "Do you want to call the candidate?",
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this._openPhoneConference();
                }
            }
        });
    };
    CandidateCardController.prototype._openPhoneConference = function () {
        var absUrl = this.StorageService.get('baseurl') + '/#/conference?c=' + this.candidateInfo.id + '&mode=PHONE';
        window.open(absUrl, '_blank');
    };
    CandidateCardController.prototype._setCandidateEmailSubjectAndBody = function (candidate) {
        var candidateInformation = {};
        candidateInformation.subject = "Candidate Information: " + candidate.name;
        candidateInformation.body = '';
        candidate.candidateAdditionalDetailsCard.preferredWorkLocations = this.candidate.workLocations;
        candidateInformation.candidateInfoInEmailBody = this.jobMatchActionsService._setCandidateInfoInEmailBody(candidate, candidate.candidateAdditionalDetailsCard);
        return candidateInformation;
    };
    CandidateCardController.prototype._setCandidateVendorDetails = function (candidate) {
        var vendorId = null;
        if (candidate.vendorName && this.allVendors) {
            this.allVendors.map(function (vendor) {
                if (vendor.name == candidate.vendorName) {
                    vendorId = vendor.id;
                }
            });
        }
        return vendorId;
    };
    return CandidateCardController;
}());
CandidateCardController.$inject = ['$uibModal', '$rootScope', '$timeout', '$state', '$filter', 'candidateService', 'jobMatchService', 'jobService', 'userRoleService', 'webSocketsService', 'StorageService', 'alertsAndNotificationsService', 'sharedAjsService', 'resumeService', 'jobMatchActionsService', 'sharedService'];
// import * as TEMPLATE from './candidate-card.html';
import * as TEMPLATE from 'raw-loader!./candidate-card.html';
export var CandidateCardComponent = {
    selector: 'candidateCard',
    component: {
        bindings: {
            'candidateInfo': '=',
            'filterParams': '=',
            'activityMap': '<',
            'salaryDurationOptions': '<',
            'candidateType': '@',
            'userId': '@',
            'jobMatchesPopoverPosition': '@',
            'setCandidateInfo': '&',
            'jobTypeList': '<',
            'jobMatchesActiveTab': "=",
            'isRowViewActive': '<',
            'allVendors': '<',
            'deleteCallback': '&'
        },
        controller: CandidateCardController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidates/candidateCard/candidate-card.html'
    }
};
//# sourceMappingURL=candidate-card.component.js.map